import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name_vi: '',
  name_en: '',
  name_jp: '',
  logo: '',
  image: '',
  search: '',
  status: 0,
};
export const companyItemSlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = companyItemSlice.actions;

export default companyItemSlice.reducer;
